import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axiosInstance from '../utils/axiosInstance';
import '../assets/css/modal.css';

const SquareModal = ({
    isOpen,
    onClose,
    onAddToCart,
    selectedSquare,
    price, // Receive price from parent
    boardFrozen, // Receive frozen status from parent
}) => {
    const [playerName, setPlayerName] = useState('');
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [players, setPlayers] = useState([]);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchPlayers = async () => {
            try {
                const response = await axiosInstance.get('/players');
                setPlayers(response.data);
            } catch (error) {
                console.error('Error fetching players:', error);
            }
        };

        if (isOpen) {
            fetchPlayers();
            setPlayerName('');
            setUserName('');
            setEmail('');
            setErrors({});
        }
    }, [isOpen]);

    const validateForm = () => {
        const newErrors = {};
        if (!playerName) newErrors.playerName = 'Please select a player.';
        if (!userName) newErrors.userName = 'Please enter your name.';
        if (!email) {
            newErrors.email = 'Please enter your email address.';
        } else if (!validateEmail(email)) {
            newErrors.email = 'Please enter a valid email address.';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleAddToCart = () => {
        if (!validateForm()) return;

        const item = {
            squareId: selectedSquare?.id,
            playerName,
            userName,
            email,
            price,
        };

        console.log('Adding to Cart:', item);
        onAddToCart(item);
        onClose();
    };

    if (!selectedSquare) return null;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            overlayClassName="modal-overlay"
            className="modal-content"
            appElement={document.getElementById('root')}
        >
            {boardFrozen ? (
                <div className="maintenance-message">
                    <h2>Maintenance Mode</h2>
                    <p>The board is currently frozen. Please check back later.</p>
                    <button className="modal-button" onClick={onClose}>
                        Close
                    </button>
                </div>
            ) : (
                <>
                    <div className="modal-header">
                        {`Square ID: ${selectedSquare?.id || 'Unlabeled'}`}
                        <button className="modal-close" onClick={onClose}>
                            ×
                        </button>
                    </div>
                    <div className="form-group">
                        <label htmlFor="player-select">Player</label>
                        <select
                            id="player-select"
                            className="modal-input"
                            value={playerName}
                            onChange={(e) => setPlayerName(e.target.value)}
                        >
                            <option value="" disabled>
                                -- Select a Player --
                            </option>
                            {players.map((player) => (
                                <option key={player._id} value={player.name}>
                                    {player.name}
                                </option>
                            ))}
                        </select>
                        {errors.playerName && <p className="error-message">{errors.playerName}</p>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="user-name">Your Name</label>
                        <input
                            id="user-name"
                            className="modal-input"
                            type="text"
                            placeholder="Enter your name"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                        />
                        {errors.userName && <p className="error-message">{errors.userName}</p>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="user-email">Your Email</label>
                        <input
                            id="user-email"
                            className="modal-input"
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>
                    <div className="modal-actions">
                        <button className="modal-button" onClick={handleAddToCart}>
                            Add to Cart
                        </button>
                    </div>
                </>
            )}
        </Modal>
    );
};

export default SquareModal;